// extracted by mini-css-extract-plugin
export default {"container":"Zo-z","ratingLayout":"_o-z","ratingLabel":"ap-z","nonInteractiveRatingLabel":"bp-z"};